<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <PropagandistTabs
        :propagandist="propagandist"
        v-model="currentTab"
        @delete="deletePropagandist"
        @edit="editPropagandist"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="propagandist">
          <PropagandistDetails :propagandist="propagandist"/>
        </v-tab-item>
        <v-tab-item value="school">
          <PropagandistSchoolDetails :propagandist="propagandist"/>
        </v-tab-item>
        <v-tab-item value="statistic">
          <PropagandistStatisticsDetails :propagandist="propagandist"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { propagandistsService } from '../../utils/services/propagandists.service';
  import PropagandistTabs from '../../components/app/Propagandists/PropagandistTabs';
  import PropagandistDetails from '../../components/app/Propagandists/PropagandistDetails';
  import PropagandistSchoolDetails from '../../components/app/Propagandists/PropagandistSchoolDetails';
  import PropagandistStatisticsDetails from '../../components/app/Propagandists/PropagandistStatisticsDetails';
  import PropagandistModal from '../../components/modals/Propagandists/PropagandistModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'PropagandistShow',
    components: {
        Loader,
        PropagandistTabs,
        PropagandistDetails,
        PropagandistSchoolDetails,
        PropagandistStatisticsDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        propagandist: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchPropagandist(id) {
        return propagandistsService.get(id)
        .then(response => {
          this.propagandist = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deletePropagandist() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return propagandistsService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(this.routeName.USER);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editPropagandist() {
          this.showModal({
              component: PropagandistModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('USER'),
                onSave: (
                  form,
                  error,
                ) => propagandistsService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchPropagandist(this.id);
      this.loading = false;
    },
  };
</script>
